import { ColDef, ValueFormatterParams } from 'ag-grid-community';

import DeleteButton from './components/DeleteButton/DeleteButton';
import AgGridStatus, { AgGridStatusParams }
  from '@/components/common/TableGrid/CustomComponents/AgGridStatus/AgGridStatus';
import { FILE_STATUS_COLORS } from '@/config/statuses.config';
import AgGridMultilineText
  from '@/components/common/TableGrid/CustomComponents/AgGridMultilineText/AgGridMultilineText';
import AgGridDateFormatter
  from '@/components/common/TableGrid/CustomFormatters/AgGridDateFormatter/AgGridDateFormatter';
import { BulkClUpdate } from './abstractions/BuldClUpdate.interface';

export function useColumns(): ColDef[] {
  return [
    {
      colId: 'EffectiveDate',
      field: 'Created',
      headerName: 'File Upload Date',
      initialWidth: 160,
      minWidth: 160,
      maxWidth: 160,
      cellClass: 'text-center',
      valueFormatter: AgGridDateFormatter
    },
    {
      colId: 'FileName',
      field: 'FileName',
      headerName: 'File Name',
    },
    {
      colId: 'Status',
      field: 'Status',
      headerName: 'Status',
      cellClass: 'text-center',
      initialWidth: 150,
      minWidth: 150,
      maxWidth: 150,
      cellRenderer: AgGridStatus,
      valueFormatter: ({ data }: ValueFormatterParams<BulkClUpdate>) => data?.StatusFormatted ?? '-',
      cellRendererParams: {
        statusColorSchema: FILE_STATUS_COLORS,
      } as AgGridStatusParams,
    },
    {
      colId: 'StatusMessage',
      field: 'StatusMessage',
      headerName: 'Message',
      wrapText: true,
      autoHeight: true,
      cellRenderer: AgGridMultilineText
    },
    {
      colId: 'delete-button',
      cellRenderer: DeleteButton,
      width: 50,
      maxWidth: 50,
      cellClass: 'p-0',
    }
  ];
}